import { Area, Unit } from '@silbo/core';

/**
 * L'unité du lit est la plus proche de ses organisations de rattachement, comme sur la plateforme web.
 *
 * @see web/src/core/locations/useActiveBeds.tsx `findManagingUnit`, la même règle, à garder alignée.
 */
export const unitOfBedFrom = (units: Unit[]): ((bed: Area) => Unit | undefined) => {
  const unitById = new Map(units.map((unit) => [unit.id, unit]));
  return (bed) => {
    const direct = bed.managingOrganization && unitById.get(bed.managingOrganization.id);
    if (direct) {
      return direct;
    }
    // Les ancêtres vont du plus haut au plus proche.
    const ancestors = bed.managingOrganizationAncestors ?? [];
    for (let index = ancestors.length - 1; index >= 0; index--) {
      const unit = unitById.get(ancestors[index].id);
      if (unit) {
        return unit;
      }
    }
    return undefined;
  };
};
